import { atom } from "jotai";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { SETUP_ICONS } from "../../cufront-assets/icons/Icons";
import { FEATURES } from "../../roles_and_permissions/_features";
import { SiLogstash } from "react-icons/si";
import { MdOutlineInventory } from "react-icons/md";
import { BsFillCreditCardFill } from "react-icons/bs";
export const CURRENCY_OPTIONS = [{ key: 1, value: "INR", text: "INR" }];

export const DR_SETUP_GROUPS = [
  {
    id: 1,
    name: "Doctor Setup",
    featureId: FEATURES.doctor_clinic_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Availability",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        fields: [],
        tableCols: [],
      },

      {
        id: 2,
        value: "Blockslot",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        fields: [],
        tableCols: [],
      },
      {
        id: 3,
        value: "Disclaimer",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        fields: [],
        tableCols: [],
      },
    ],
    icon: SETUP_ICONS.dr_clinic,
    width: "34px",
    height: "40px",
    route: "/availability",
    description: "Set time and availability of doctors and clinics",
  },
  {
    id: 2,
    name: "Consultation Setup",
    featureId: FEATURES.consultation_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Vitals",
        offset: ApiEndPoint.QP_CM_VITAL_TYPE,
        query: `?action=getVitalTypes&frontend=True`,
        postAction: "postVitalTypes",
        editAction: "patchVitalTypes",
        deleteAction: "delVitalTypes",
        searchKey: "label",
        isDrFilter: true,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "No Of Fields", type: "number", required: true },
          { id: 3, label: "Max Length", type: "number", required: true },
          { id: 4, label: "Unit", type: "text", required: true },
          { id: 5, label: "Seperator", type: "text", required: false },
        ],
        tableCols: [
          { id: 1, label: "Label" },
          { id: 2, label: "No Of Fields" },
          { id: 3, label: "Max Length" },
          { id: 4, label: "Unit" },
          { id: 5, label: "Seperator" },
        ],
      },
      // {
      //   id: 2,
      //   value: "Custom Fields",
      //   offset: ApiEndPoint.QP_CM_TAG_TYPES,
      //   query: `?action=getTagTypes&frontend=True`,
      //   postAction: "postTagTypes",
      //   editAction: "patchTagTypes",
      //   searchKey: "name",
      //   isDrFilter: false,
      //   isSeprate: false,
      //   isEdit: true,
      //   isDelete: false,
      //   fields: [
      //     // { id: 1, label: "Label", type: "text", required: true },
      //     { id: 2, label: "Name", type: "text", required: true },
      //   ],
      //   tableCols: [
      //     // { id: 1, label: "Label" },
      //     { id: 2, label: "Name" },
      //   ],
      // },
      {
        id: 3,
        value: "Dosage",
        offset: ApiEndPoint.QP_CM_DOSAGE,
        query: `?action=getDosages&frontend=True`,
        postAction: "postDosages",
        editAction: "patchDosages",
        deleteAction: "delDosages",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          { id: 2, label: "Name" },
        ],
      },
      {
        id: 4,
        value: "Units",
        offset: ApiEndPoint.QP_CM_UNITS,
        query: `?action=getUnits&frontend=True`,
        postAction: "postUnits",
        editAction: "patchUnits",
        deleteAction: "delUnits",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          { id: 2, label: "Name" },
        ],
      },
      {
        id: 5,
        value: "Frequency",
        offset: ApiEndPoint.QP_CM_FREQUENCY,
        query: `?action=getFrequency&frontend=True`,
        postAction: "postFrequency",
        editAction: "patchFrequency",
        deleteAction: "delFrequency",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          { id: 2, label: "Name" },
        ],
      },
      {
        id: 6,
        value: "When",
        offset: ApiEndPoint.QP_CM_WHEN,
        query: `?action=getWhen&frontend=True`,
        postAction: "postWhen",
        editAction: "patchWhen",
        deleteAction: "delWhen",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          { id: 2, label: "Name" },
        ],
      },
      {
        id: 7,
        value: "Medicine Type",
        offset: ApiEndPoint.QP_CM_MEDICINE_TYPE,
        query: `?action=getMedicineTypes&frontend=True`,
        postAction: "postMedicineTypes",
        editAction: "patchMedicineTypes",
        deleteAction: "delMedicineTypes",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          { id: 2, label: "Name" },
        ],
      },
      {
        id: 8,
        value: "Advice and Direction",
        offset: ApiEndPoint.CONSULTATION,
        query: `?action=getAdvices&frontend=True`,
        postAction: "postAdvices",
        editAction: "patchAdvices",
        deleteAction: "delAdvices",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Description", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Description" },
        ],
      },
    ],
    icon: SETUP_ICONS.consultation,
    width: "50px",
    height: "40px",
    route: "/",
    description: "Establish and specify digital prescription fields",
  },
  {
    id: 3,
    name: "Medicine Setup",
    featureId: FEATURES.medicine_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Medicine Name",
        offset: ApiEndPoint.QP_CM_MEDICINE_DATA,
        query: `?action=getMedicineData&frontend=True&medicine_data=True`,
        postAction: "postMedicineData",
        editAction: "patchMedicineData",
        searchKey: "medicine_name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          { id: 1, label: "Medicine Name", type: "text", required: true },
          { id: 2, label: "Generic Name", type: "text", required: true },
          { id: 3, label: "Dosage", type: "text", required: true },
          { id: 4, label: "Unit", type: "text", required: true },
          { id: 5, label: "When", type: "text", required: true },
          { id: 6, label: "Frequency", type: "text", required: true },
          // { id: 7, label: "Duration", type: "text", required: true },
          { id: 8, label: "Notes", type: "text", required: true },
          { id: 9, label: "Medicine Type", type: "text", required: true },
          // { id: 10, label: "Category", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Medicine Name" },
          { id: 2, label: "Generic Name" },
          { id: 3, label: "Dosage" },
          { id: 4, label: "Unit" },
          { id: 5, label: "When" },
          { id: 6, label: "Frequency" },
          // { id: 7, label: "Duration" },
          { id: 8, label: "Notes" },
          { id: 9, label: "Medicine Type" },
          // { id: 10, label: "Category" },
        ],
      },
      {
        id: 2,
        value: "Generic Name",
        offset: ApiEndPoint.QP_CM_GENERIC_NAME,
        query: `?action=getGenericName&frontend=True`,
        postAction: "postGenericName",
        editAction: "patchGenericName",
        deleteAction: "delGenericName",
        searchKey: "name__startswith",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [{ id: 1, label: "Name", type: "text", required: true }],
        tableCols: [{ id: 1, label: "Name" }],
      },
    ],
    icon: SETUP_ICONS.medicine,
    width: "36px",
    height: "40px",
    route: "/",
    description: "Manage and document medication and generics",
  },
  {
    id: 4,
    name: "Customer Setup",
    featureId: FEATURES.customer_master.feature_id,
    options: [
      {
        id: 1,
        value: "Customer Master",
        offset: ApiEndPoint.INSTITUTION_CUSTOMERS,
        query: `?action=getInstitutionCustomers&frontend=True`,
        postAction: "postInstitutionCustomers",
        editAction: "patchInstitutionCustomers",
        deleteAction: "delInstitutionCustomers",
        searchKey: "institution_name__icontains",
        fields: [
          { id: 1, label: "Institution name", type: "text", required: true },
          { id: 2, label: "Contact person name", type: "text", required: true },
          { id: 3, label: "Contact number", type: "number", required: true },
          { id: 4, label: "Email address", type: "email", required: true },
          { id: 5, label: "Status", type: "text", required: true },
          { id: 6, label: "Payment Terms", type: "dropdown", required: true },
        ],
        tableCols: [
          { id: 1, label: "Institution name" },
          { id: 2, label: "Billing address" },
          { id: 3, label: "Communication address" },
          { id: 4, label: "Contact person name" },
          { id: 5, label: "Contact number" },
          { id: 6, label: "Email address" },
          { id: 7, label: "Status" },
        ],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.customer,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Establish and store institutiional data",
  },
  {
    id: 5,
    name: "Service Setup",
    featureId: FEATURES.service_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Service Master",
        offset: ApiEndPoint.CLINIC_SERVICES,
        query: `?action=getClinicServices&frontend=True`,
        postAction: "postClinicServices",
        editAction: "patchClinicServices",
        deleteAction: "delClinicServices",
        searchKey: "name_of_service",
        fields: [
          { id: 1, label: "Name of service", type: "text", required: true },
          { id: 2, label: "Service Type", type: "text", required: true },
          { id: 3, label: "Description", type: "text", required: true },
          { id: 4, label: "Price", type: "number", required: true },
          {
            id: 5,
            label: "Currency",
            type: "dropdown",
            required: true,
            options: CURRENCY_OPTIONS,
          },
        ],
        tableCols: [
          { id: 1, label: "Name of service" },
          { id: 2, label: "Service Type" },
          { id: 3, label: "Description" },
          { id: 4, label: "Price" },
          { id: 5, label: "Currency" },
        ],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      // {
      //   id: 2,
      //   value: "Procedure master",
      //   offset: "",
      //   query: "",
      //   fields: [],
      //   buttons: [],
      //   isDrFilter: false,
      //   isClinicFilter: false,
      //   isEdit: true,
      //   isDelete: false,
      // },
      {
        id: 3,
        value: "Package Master",
        offset: ApiEndPoint.CLINIC_PACKAGES,
        query: `?action=getClinicPackages&frontend=True`,
        postAction: "postClinicPackages",
        editAction: "patchClinicPackages",
        deleteAction: "delClinicPackages",
        searchKey: "name_of_package",
        fields: [
          { id: 1, label: "Name of package", type: "text", required: true },
          { id: 2, label: "Description", type: "text", required: true },
          { id: 3, label: "Price", type: "number", required: true },
          { id: 4, label: "Select services", type: "dropdown", required: true },
          { id: 5, label: "Discount", type: "number", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name of package", type: "text", required: true },
          { id: 2, label: "Description", type: "text", required: true },
          { id: 3, label: "Price", type: "number", required: true },
          { id: 4, label: "Services", type: "radio", required: true },
          { id: 5, label: "Discount", type: "number", required: true },
        ],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.service,
    width: "47px",
    height: "40px",
    route: "/",
    description: "Document medical procedures and service packages",
  },
  {
    id: 6,
    name: "Language Model",
    featureId: FEATURES.language_model.feature_id,
    options: [
      {
        id: 1,
        value: "Add Language",
        offset: ApiEndPoint.QP_CM_LANGUAGE,
        query: `?action=getLanguages&frontend=True`,
        postAction: "postLanguages",
        editAction: "patchLanguages",
        deleteAction: "delLanguages",
        searchKey: "name",
        fields: [{ id: 1, label: "Name", type: "text", required: true }],
        tableCols: [{ id: 1, label: "Name" }],
        // buttons: [
        //   {
        //     id: 1,
        //     label: "Save",
        //     type: "submit",
        //     btnStyle: "cu-setup-create-form-save-btn",
        //   },
        //   {
        //     id: 2,
        //     label: "Cancel",
        //     type: "button",
        //     btnStyle: "cu-setup-create-form-cancel-btn",
        //   },
        // ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 2,
        value: "Add Translation",
        offset: ApiEndPoint.TRANSLATION,
        query: `?action=getCustomTranslation&frontend=True`,
        postAction: "postCustomTranslation",
        editAction: "patchCustomTranslation",
        deleteAction: "delCustomTranslation",
        // fields: [{ id: 1, label: "Name", type: "text", required: true }],
        tableCols: [{ id: 1, label: "Name" }],
        // buttons: [
        //   {
        //     id: 1,
        //     label: "Save",
        //     type: "submit",
        //     btnStyle: "cu-setup-create-form-save-btn",
        //   },
        //   {
        //     id: 2,
        //     label: "Cancel",
        //     type: "button",
        //     btnStyle: "cu-setup-create-form-cancel-btn",
        //   },
        // ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.language,
    width: "67.13px",
    height: "40px",
    route: "/",
    description: "Add translation and language",
  },

  {
    id: 7,
    name: "Template Setup",
    featureId: FEATURES.template_setup.feature_id,
    options: [
      // {
      //   id: 1,
      //   value: "Certificate Setup",
      //   offset: "",
      //   query: ``,
      //   postAction: "",
      //   editAction: "",
      //   isDrFilter: false,
      //   isClinicFilter: false,
      //   isEdit: true,
      //   isDelete: false,
      // },
      {
        id: 1,
        value: "Prescription Setup",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: false,
      },

      {
        id: 2,
        value: "Header & Footer Setup",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        tagId: 1,
        fields: [],
        tableCols: [],
      },
      // {
      //   id: 3,
      //   value: "Questionnaire",
      //   offset: "",
      //   query: ``,
      //   postAction: "",
      //   editAction: "",
      //   isDrFilter: false,
      //   isClinicFilter: false,
      //   isEdit: true,
      //   isDelete: false,
      // },
      {
        id: 4,
        value: "Certificate",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: false,
      },
    ],
    icon: SETUP_ICONS.template,
    width: "40px",
    height: "40px",
    route: "/",
    description: "Create print and certificate template",
  },
  {
    id: 8,
    name: "Consultation Master",
    featureId: FEATURES.consultation_master_data.feature_id,
    options: [
      {
        id: 1,
        value: "Complaints",
        offset: ApiEndPoint.QP_CM_TAGS,
        query: `?action=getTags&frontend=True&tag_type=COMPLAINTS`,
        postAction: "postTags",
        editAction: "patchTags",
        deleteAction: "delTags",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        tagId: "COMPLAINTS",
        searchKey: "name",
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Value", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Value" },
        ],
      },
      {
        id: 2,
        value: "Diagnosis",
        offset: ApiEndPoint.QP_CM_TAGS,
        query: `?action=getTags&frontend=True&tag_type=DIAGNOSIS`,
        postAction: "postTags",
        editAction: "patchTags",
        deleteAction: "delTags",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        tagId: "DIAGNOSIS",
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Value", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Value" },
        ],
      },
      {
        id: 3,
        value: "Test & Investigation",
        offset: ApiEndPoint.QP_CM_TAGS,
        query: `?action=getTags&frontend=True&tag_type=TESTINVESTIGATION`,
        postAction: "postTags",
        editAction: "patchTags",
        deleteAction: "delTags",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        tagId: "TEST&INVESTIGATION",
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Value", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Value" },
        ],
      },
    ],
    icon: "",
    icon: SETUP_ICONS.consultation_master,
    width: "36.58px",
    height: "40px",
    route: "/",
    description:
      "Set parameters for complaints, diagnosis, tests, and investigations",
  },
  // {
  //   id: 9,
  //   name: "Header & Footer Setup",
  //   featureId: FEATURES.header_and_footer_setup.feature_id,
  //   options: [
  //     {
  //       id: 1,
  //       value: "Header & Footer Setup",
  //       offset: "",
  //       query: ``,
  //       postAction: "",
  //       editAction: "",
  //       isDrFilter: false,
  //       isSeprate: false,
  //       isEdit: true,
  //       isDelete: false,
  //       tagId: 1,
  //       fields: [],
  //       tableCols: [],
  //     },
  //   ],
  //   icon: SETUP_ICONS.header_and_footer,
  //   width: "32px",
  //   height: "40px",
  //   route: "/",
  //   description: "Create header and footer for visiting pad",
  // },
  {
    id: 9,
    name: "TV View Setup",
    featureId: FEATURES.tv_view_setup.feature_id,
    options: [
      {
        id: 1,
        value: "TV View",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        fields: [
          // { id: 1, label: "Label", type: "text", required: true },
          // { id: 2, label: "Name", type: "text", required: true },
        ],
        tableCols: [
          // { id: 1, label: "Label" },
          // { id: 2, label: "Name" },
        ],
      },
    ],
    icon: SETUP_ICONS.tv_view,
    width: "51.95px",
    height: "40px",
    route: "/tv_view_setup/10",
    description: "Configure fields and notices for TV display",
  },
  // {
  //   id: 11,
  //   name: "Billing Setup",
  //   featureId: FEATURES.billing_setup.feature_id,
  //   options: [],
  //   icon: SETUP_ICONS.billing,
  //   width: "36px",
  //   height: "40px",
  //   route: "/billing_setup/11",
  //   description: "Configure billing functions",
  // },
  {
    id: 12,
    name: "Groups Setup",
    featureId: FEATURES.groups_setup.feature_id,
    options: [
      {
        id: 1,
        value: "RX Group",
        offset: ApiEndPoint.QP_CM_RX_GROUP,
        query: `?action=getRxGroup&frontend=True`,
        postAction: "postRxGroup",
        editAction: "patchRxGroup",
        deleteAction: "delRxGroup",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          {
            id: 2,
            label: "Select Medicines",
            type: "dropdown",
            required: true,
          },
        ],
        tableCols: [{ id: 1, label: "Name" }],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 2,
        value: "TAG Group",
        offset: ApiEndPoint.QP_CM_TAG_GROUPS,
        query: `?action=getTagGroups&frontend=True`,
        postAction: "postTagGroups",
        editAction: "patchTagGroups",
        deleteAction: "delTagGroups",
        fields: [
          {
            id: 1,
            label: "Group Name",
            type: "text",
            required: true,
          },
          {
            id: 2,
            label: "Group For",
            type: "dropdown",
            required: true,
          },
          {
            id: 3,
            label: "Select Tags",
            type: "dropdown",
            required: true,
          },
        ],
        tableCols: [
          { id: 1, label: "Group Name" },
          { id: 2, label: "Group For" },
        ],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.group,
    width: "40px",
    height: "40px",
    route: "/group_setup/12",
    description: "Create Rx And TAG groups.",
  },
  {
    id: 13,
    name: "General Setup",
    featureId: FEATURES.general_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Number Sequence",
        offset: ApiEndPoint.NUMBER_SEQUENCE,
        query: `?action=getNumberSequence&frontend=True`,
        postAction: "postNumberSequence",
        editAction: "patchNumberSequence",
        deleteAction: "delNumberSequence",
        searchKey: "transaction_type",
        fields: [
          {
            id: 1,
            label: "Transaction type",
            type: "dropdown",
            required: true,
          },
          { id: 2, label: "Prefix", type: "text", required: true },
          {
            id: 3,
            label: "Range start number",
            type: "number",
            required: true,
          },
          {
            id: 4,
            label: "Length of incremental number",
            type: "number",
            required: true,
          },
        ],
        tableCols: [
          // { id: 1, label: "Transaction type" },
          { id: 1, label: "Prefix" },
          {
            id: 2,
            label: "Range start number",
          },
          {
            id: 3,
            label: "Length of incremental number",
          },
        ],

        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 2,
        value: "Service Type",
        offset: ApiEndPoint.CLINIC_SERVICES,
        query: `?action=getServiceType&backend=True`,
        postAction: "postServiceType",
        editAction: "patchServiceType",
        deleteAction: "delServiceType",
        searchKey: "name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          { id: 2, label: "Description", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Description" },
        ],
        isDrFilter: false,
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 3,
        value: "Unit of Measure",
        offset: ApiEndPoint.CLINIC,
        query: `?action=getUnitsOfMeasure&backend=True`,
        postAction: "postUnitsOfMeasure",
        editAction: "patchUnitsOfMeasure",
        deleteAction: "delUnitsOfMeasure",
        searchKey: "name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          { id: 2, label: "Description", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Description" },
        ],
        isDrFilter: false,
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 4,
        value: "Mode of Payment",
        offset: ApiEndPoint.PAYMENT_OPTIONS,
        query: `?action=getPaymentOptions&frontend=True`,
        postAction: "postPaymentOptions",
        editAction: "patchPaymentOptions",
        deleteAction: "delPaymentOptions",
        searchKey: "type",
        fields: [
          {
            id: 1,
            label: "Mode of Payment",
            type: "text",
            required: true,
          },
        ],
        tableCols: [{ id: 1, label: "Mode of Payment" }],
        isDrFilter: false,
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.general,
    width: "40.61px",
    height: "40px",
    route: "/group_setup/13",
    description: "Manage and specify general settings.",
  },
  {
    id: 14,
    name: "Clinic Setup",
    featureId: FEATURES.template_setup.feature_id,
    options: [
      {
        id: 1,
        value: "Roles and Permission",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: false,
      },
      {
        id: 2,
        value: "Users",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: false,
      },
      {
        id: 3,
        value: "Ward",
        offset: ApiEndPoint.INVENTORY,
        query: `?action=getWard&backend=True`,
        postAction: "postWard",
        editAction: "patchWard",
        deleteAction: "delWard",
        isDrFilter: false,
        isClinicFilter: true, //   isLoading={updateSettings?.isLoading}
        isEdit: true,
        isDelete: true,
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Type", type: "text", required: true },
          { id: 3, label: "Description", type: "text", required: true },
          { id: 4, label: "Bed Capacity", type: "text", required: true },
          { id: 5, label: "Amenities", type: "text", required: true }, // multi-dropdown
          { id: 6, label: "Cost Per day", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 1, label: "Type" },
          { id: 3, label: "Description", type: "text" },
          { id: 4, label: "Bed Capacity", type: "text" },
          { id: 5, label: "Amenities", type: "text" }, // multi-dropdown
          { id: 6, label: "Cost Per day", type: "text" },
        ],
      },
      {
        id: 4,
        value: "Department",
        offset: ApiEndPoint.CLINIC,
        query: `?action=getDepartment&backend=True`,
        postAction: "postDepartment",
        editAction: "patchDepartment",
        deleteAction: "delDepartment",
        isDrFilter: false,
        isClinicFilter: true, //   isLoading={updateSettings?.isLoading}
        isEdit: true,
        isDelete: true,
        fields: [
          { id: 1, label: "Name", type: "text", required: true },
          { id: 2, label: "Description", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name", type: "text" },
          { id: 2, label: "Description", type: "text" },
        ],
      },
      // {
      //   id: 4,
      //   value: "Custom Field Setup",
      //   offset: "",
      //   query: ``,
      //   postAction: "",
      //   editAction: "",
      //   isDrFilter: false,
      //   isClinicFilter: false, //   isLoading={updateSettings?.isLoading}
      //   isEdit: true,
      //   isDelete: false,
      // },
    ],
    icon: SETUP_ICONS.template,
    width: "40px",
    height: "40px",
    route: "/",
    description: "Create Roles & Permission and Custom Fields",
  },
  {
    id: 15,
    name: "Logs",
    featureId: FEATURES.logs.feature_id,
    options: [
      {
        id: 1,
        value: "Notification Logs",
        offset: ApiEndPoint.LOGS,
        query: `?action=getExternalNotificationLogs&backend=True`,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        tableCols: [
          { id: 1, label: "Send To" },
          { id: 2, label: "Message" },
          {
            id: 3,
            label: "Date Created",
          },
        ],
        isClinicFilter: false,
        isEdit: true,
        isDelete: false,
      },
    ],
    icon: <SiLogstash size={39} color="green" />,
    width: "40px",
    height: "40px",
    route: "/",
    description: "Check your messages logs here",
  },
  {
    id: 16,
    name: "Inventory",
    featureId: FEATURES.inventory.feature_id,
    options: [
      {
        id: 1,
        value: "Medicine Stock",
        offset: ApiEndPoint.INVENTORY,
        query: `?action=getMedicineStock&backend=true`,
        postAction: "postMedicineStock",
        editAction: "patchMedicineStock",
        deleteAction: "delMedicineStock",
        isDrFilter: false,
        searchKey: "medicine_name",
        fields: [
          { id: 1, label: "Medicine", type: "dropdown", required: true },
          { id: 2, label: "Batch No", type: "dropdown", required: true },
          {
            id: 3,
            label: "Inward Quantity",
            type: "number",
            required: true,
          },
          {
            id: 4,
            label: "Unit of Measure",
            type: "dropdown",
            required: true,
          },
          {
            id: 5,
            label: "Expiry Date",
            type: "date",
            required: true,
          },
          {
            id: 6,
            label: "Price",
            type: "number",
            required: true,
          },
          { id: 7, label: "Received Date", type: "date", required: true },
          // {
          //   id: 8,
          //   label: "Available Batch Qty",
          //   type: "number",
          //   required: true,
          // },
          // {
          //   id: 9,
          //   label: "Total Available Qty",
          //   type: "number",
          //   require: true,
          // },
        ],
        tableCols: [
          { id: 1, label: "Medicine" },
          { id: 2, label: "Batch No" },
          {
            id: 3,
            label: "Inward Quantity",
          },
          {
            id: 4,
            label: "Unit of Measure",
          },
          {
            id: 5,
            label: "Expiry Date",
          },
          {
            id: 6,
            label: "Price",
          },
          { id: 7, label: "Received Date" },
          { id: 8, label: "Available Batch Qty" },
          { id: 9, label: "Total Available Qty" },
        ],
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 2,
        value: "Batch",
        offset: ApiEndPoint.INVENTORY,
        query: "?action=getBatchMaster&backend=True",
        postAction: "postBatchMaster",
        editAction: "patchBatchMaster",
        deleteAction: "delBatchMaster",
        isDrFilter: false,
        searchKey: "batch_number",
        fields: [
          { id: 1, label: "Batch No", type: "dropdown", required: true },
          { id: 2, label: "Description", type: "text", required: true },
          {
            id: 3,
            label: "Select Medicine",
            type: "dropdown",
            required: true,
          },
          {
            id: 4,
            label: "Batch Creation Date",
            type: "date",
            required: true,
          },
          {
            id: 5,
            label: "Manufacture Date",
            type: "date",
            required: true,
          },
          {
            id: 6,
            label: "Expiry",
            type: "date",
            required: true,
          },
        ],
        tableCols: [
          { id: 1, label: "Batch No" },
          {
            id: 2,
            label: "Medicine",
          },
          {
            id: 3,
            label: "Batch Creation Date",
          },
          {
            id: 4,
            label: "Manufacture Date",
          },
          {
            id: 5,
            label: "Expiry Date",
          },
        ],
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 3,
        value: "Stock",
        offset: ApiEndPoint.INVENTORY,
        query: "?action=getStocks&backend=True",
        postAction: "postStocks",
        editAction: "patchStocks",
        deleteAction: "delStocks",
        isDrFilter: false,
        searchKey: "property_no",
        fields: [
          { id: 1, label: "Property No", type: "text", required: true },
          { id: 2, label: "Quantity", type: "text", required: true },
          { id: 3, label: "Select Item", type: "dropdown", required: true },
          {
            id: 4,
            label: "Select Location",
            type: "dropdown",
            required: true,
          },
          {
            id: 4,
            label: "Stock Creation Date",
            type: "date",
            required: true,
          },
          { id: 5, label: "Serial No", type: "text", required: true },
          { id: 6, label: "Manufacture", type: "text", required: true },
          { id: 7, label: "Purchese Date", type: "date", required: true },
          {
            id: 8,
            label: "Maitanance Schedule",
            type: "dropdown",
            required: true,
          },
          {
            id: 9,
            label: "Condition Status",
            type: "dropdown",
            required: true,
          },
        ],
        tableCols: [
          { id: 1, label: "Property No" },
          {
            id: 2,
            label: "Quantity",
          },
          {
            id: 3,
            label: "Select Item",
          },
          {
            id: 4,
            label: "Select Location",
          },
          { id: 5, label: "Serial No" },
          { id: 6, label: "Manufacture" },
          { id: 7, label: "Purchese Date" },
          {
            id: 8,
            label: "Maitanance Schedule",
          },
          {
            id: 9,
            label: "Condition Status",
          },
        ],
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 4,
        value: "Items",
        offset: ApiEndPoint.INVENTORY,
        query: "?action=getItem&backend=True",
        postAction: "postItem",
        editAction: "patchItem",
        deleteAction: "delItem",
        isDrFilter: false,
        searchKey: "name",
        fields: [
          { id: 1, label: "Code", type: "text", required: true },
          { id: 2, label: "Name", type: "text", required: true },
          { id: 3, label: "Type", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Code" },
          { id: 2, label: "Name" },
          {
            id: 3,
            label: "Type",
          },
        ],
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: <MdOutlineInventory size={40} />,
    width: "40px",
    height: "40px",
    route: "/",
    description: "Manage Inventories",
  },
  {
    id: 17,
    name: "Test and Investigation",
    featureId: FEATURES?.testAndInvestigation.feature_id,
    options: [
      {
        id: 1,
        value: "Lab Tests",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getLabTest&backend=True`,
        postAction: "postLabTest",
        editAction: "patchLabTest",
        deleteAction: "delLabTest",
        searchKey: "display_name",
        // fields: [
        //   {
        //     id: 1,
        //     label: "Transaction type",
        //     type: "dropdown",
        //     required: true,
        //   },
        //   { id: 2, label: "Prefix", type: "text", required: true },
        //   {
        //     id: 3,
        //     label: "Range start number",
        //     type: "number",
        //     required: true,
        //   },
        //   {
        //     id: 4,
        //     label: "Length of incremental number",
        //     type: "number",
        //     required: true,
        //   },
        // ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Display Name" },
          { id: 3, label: "UFM" },
          { id: 4, label: "Related Names" },
          {
            id: 5,
            label: "Test Category",
          },
          {
            id: 6,
            label: "Lab Test Threshold",
          },
        ],

        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 2,
        value: "Categories",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getLabTestCategories&clinic_id=1&backend=True`,
        postAction: "postLabTestCategories",
        editAction: "patchLabTestCategories",
        deleteAction: "delLabTestCategories",
        searchKey: "display_name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          { id: 2, label: "Display Name", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Display Name" },
          { id: 2, label: "Name" },
        ],
        isDrFilter: false,
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 3,
        value: "UFM",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getLabUfm&clinic_id=1&backend=True`,
        postAction: "postLabUfm",
        editAction: "patchLabUfm",
        deleteAction: "delLabUfm",
        searchKey: "display_name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          { id: 2, label: "Display Name", type: "text", required: true },
        ],
        tableCols: [
          { id: 1, label: "Name" },
          { id: 2, label: "Display Name" },
        ],
        isDrFilter: false,
        isClinicFilter: true,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 4,
        value: "Lab Tests Threshold",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getLabTestThreshold&backend=True`,
        postAction: "postLabTestThreshold",
        editAction: "patchLabTestThreshold",
        deleteAction: "delLabTestThreshold",
        searchKey: "age_group",
        tableCols: [
          { id: 1, label: "Max Threshold" },
          { id: 2, label: "Min Threshold" },
          {
            id: 3,
            label: "Age group",
          },
          {
            id: 4,
            label: "gender",
          },
        ],

        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 5,
        value: "Age Group",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getAgeGroup&backend=True`,
        postAction: "postAgeGroup",
        editAction: "patchAgeGroup",
        deleteAction: "delAgeGroup",
        searchKey: "name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
        ],
        tableCols: [{ id: 1, label: "Name" }],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
      {
        id: 5,
        value: "Gender",
        offset: ApiEndPoint?.MEDICINE_TAG_DATA,
        query: `?action=getGender&backend=True`,
        postAction: "postGender",
        editAction: "patchGender",
        searchKey: "name",
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
        ],
        tableCols: [{ id: 1, label: "Name" }],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.general,
    width: "40.61px",
    height: "40px",
    route: "/group_setup/17",
    description: "Manage Investigation and Master.",
  },
  {
    id: 18,
    name: "Credit",
    featureId: FEATURES.creditAndTransaction.feature_id,
    options: [
      {
        id: 1,
        value: "Credit",
        offset: ApiEndPoint.SUBSCRIPTIONS,
        query: `?action=getInwardTransacation&backend=True`,
        // postAction: "postNumberSequence",
        // editAction: "patchNumberSequence",
        // deleteAction: "delNumberSequence",
        searchKey: "credit_used",
        tableCols: [
          { id: 1, label: "Received Date" },
          { id: 2, label: "Received From" },
          { id: 2, label: "Credit Name" },
          {
            id: 3,
            label: "Total Credits",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        // isEdit: true,
        // isDelete: false,
      },
      {
        id: 2,
        value: "Transactions",
        offset: ApiEndPoint.SUBSCRIPTIONS,
        query: `?action=getConsumeTransaction&backend=True`,
        // postAction: "postNumberSequence",
        // editAction: "patchNumberSequence",
        // deleteAction: "delNumberSequence",
        searchKey: "credit_used",
        // fields: [
        //   {
        //     id: 1,
        //     label: "Name",
        //     type: "text",
        //     required: true,
        //   },
        //   { id: 2, label: "Description", type: "text", required: true },
        // ],
        tableCols: [
          { id: 1, label: "Date Consumed" },
          { id: 2, label: "Time" },
          {
            id: 3,
            label: "Feature Name",
          },
          {
            id: 4,
            label: "Credit Used",
          },
        ],
        isDrFilter: false,
        isClinicFilter: true,
        // isEdit: true,
        // isDelete: false,
      },
    ],
    icon: <BsFillCreditCardFill size={39} color="#3592FF" />,
    width: "40.61px",
    height: "40px",
    route: "/group_setup/18",
    description: "Manage and specify general settings.",
  },
  {
    id: 19,
    name: "Notification Setup",
    featureId: FEATURES.notificationSetup.feature_id,
    options: [
      {
        id: 1,
        value: "Notification",
        offset: "",
        query: ``,
        postAction: "",
        editAction: "",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: false,
        fields: [],
        tableCols: [],
      },
    ],
    icon: SETUP_ICONS.dr_clinic,
    width: "34px",
    height: "40px",
    route: "/availability",
    description: "Set time and availability of doctors and clinics",
  },
  {
    id: 20,
    name: "IPD Setup",
    featureId: FEATURES?.ipdSetup.feature_id,
    icon: SETUP_ICONS.ipd,
    width: "34px",
    height: "40px",
    route: "/setup",
    description: "Setup IPD in your clinic",

    options: [
      {
        id: 1,
        value: "Procedure",
        offset: ApiEndPoint.IPD,
        query: "?action=getProcedureMaster&backend=True",
        postAction: "postProcedureMaster",
        editAction: "patchProcedureMaster",
        deleteAction: "delProcedureMaster",
        searchKey: "name",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          {
            id: 1,
            label: "Name",
            type: "text",
            required: true,
          },
          {
            id: 2,
            label: "Select Steps",
            type: "multi-select",
          },
        ],
        tableCols: [{ id: 1, label: "Name" }],
      },
      {
        id: 2,
        value: "Step",
        offset: ApiEndPoint.IPD,
        query: "?action=getStep&backend=True",
        postAction: "postStep",
        editAction: "patchStep",
        deleteAction: "delStep",
        searchKey: "name",
        isDrFilter: false,
        isSeprate: false,
        isEdit: true,
        isDelete: true,
        fields: [
          {
            id: 1,
            label: "name",
            type: "custom-field",
          },
        ],
        tableCols: [{ id: 1, label: "Name" }],
      },
    ],
  },
  {
    id: 21,
    name: "Procedure Setup",
    featureId: FEATURES?.ipdSetup.feature_id,
    icon: SETUP_ICONS.ipd,
    width: "34px",
    height: "40px",
    route: "/setup",
    description: "Setup your IPD",

    options: [],
  },
  {
    id: 22,
    key: "Items",
    name: "Items Setup",
    featureId: FEATURES?.pharmacySetup?.feature_id,
    icon: SETUP_ICONS.pharmacy,
    width: "34px",
    height: "40px",
    route: "/setup",
    description: "Add your Items",
    options: [],
  },

  {
    id: 23,
    name: "Vendor Setup",
    featureId: FEATURES?.vendorSetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.customer,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Establish and store institutiional data",
  },
  {
    id: 24,
    name: "Warehouse & Logistics",
    featureId: FEATURES?.warehouseSetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.warehouse,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Setup Stock Location Hierarchy",
  },
  {
    id: 25,
    name: "Workflow Setup",
    featureId: FEATURES?.workflowSetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.workflow,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Setup your workflow order",
  },
  {
    id: 26,
    name: "Insurance Providers Setup",
    featureId: FEATURES.customer_master.feature_id,
    options: [
      {
        id: 1,
        value: "Insurance Provider Master",
        offset: ApiEndPoint.INSTITUTION_CUSTOMERS,
        query: `?action=getInstitutionCustomers&frontend=True`,
        postAction: "postInstitutionCustomers",
        editAction: "patchInstitutionCustomers",
        deleteAction: "delInstitutionCustomers",
        searchKey: "institution_name__icontains",
        fields: [
          { id: 1, label: "Provider name", type: "text", required: true },
          { id: 2, label: "Contact person name", type: "text", required: true },
          { id: 3, label: "Contact number", type: "number", required: true },
          { id: 4, label: "Email address", type: "email", required: true },
          { id: 5, label: "Status", type: "text", required: true },
          { id: 6, label: "Payment Terms", type: "dropdown", required: true },
        ],
        tableCols: [
          { id: 1, label: "Provider name" },
          { id: 2, label: "Billing address" },
          { id: 3, label: "Communication address" },
          { id: 4, label: "Contact person name" },
          { id: 5, label: "Contact number" },
          { id: 6, label: "Email address" },
          { id: 7, label: "Status" },
        ],
        buttons: [
          {
            id: 1,
            label: "Save",
            type: "submit",
            btnStyle: "cu-setup-create-form-save-btn",
          },
          {
            id: 2,
            label: "Cancel",
            type: "button",
            btnStyle: "cu-setup-create-form-cancel-btn",
          },
        ],
        isDrFilter: false,
        isClinicFilter: false,
        isEdit: true,
        isDelete: true,
      },
    ],
    icon: SETUP_ICONS.customer,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Establish and store institutiional data",
  },

  {
    id: 27,
    name: "Preconsultation Setup",
    featureId: FEATURES?.preconsultationSetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.preconsultation,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Setup your Preconsultation",
  },
  {
    id: 28,
    name: "Unit of Measure Setup",
    featureId: FEATURES?.pharmacySetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.unitofMeasure,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Setup your Unit of Measure",
  },
  {
    id: 29,
    name: "Manage Medicine Schedules",
    featureId: FEATURES?.pharmacySetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.medicineSchedule,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Manage Medicine Schedules",
  },
  {
    id: 30,
    name: "Pharmacy Linked Doctor Setup",
    featureId: FEATURES?.pharmacySetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.pharmacy_linked_doctor,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Integrate pharmacy operations with a doctor network.",
  },
  {
    id: 31,
    name: "Ward Management",
    featureId: FEATURES?.ipdSetup?.feature_id,
    options: [],
    icon: SETUP_ICONS?.ward_management,
    width: "32px",
    height: "40px",
    route: "/",
    description: "Setup Rooms Wards and Beds",
  },
];

export const pageSizes = {
  A4: { width: 21, height: 29.7 },
  A5: { width: 14.8, height: 21 },
  A3: { width: 29.7, height: 42 },
  // Add more page sizes as needed
};

export const editAtom = atom({
  data: {},
  flag: false,
  isView: false,
});

export const createAtom = atom(false);
